<template>
  <div class="unauthorized" height="100%">
    <v-overlay absolute>
      <v-card max-width="500px">
        <v-card-title class="error--text">
          <v-icon color="error">mdi-exclamation</v-icon>
          <span>Unauthorized</span>
        </v-card-title>
        <v-card-subtitle class="mt-3"
          >You do not have rights to access this page. Please contact your
          administrator.</v-card-subtitle
        >
        <v-card-actions>
          <v-row>
            <v-col align="center">
              <v-btn @click="logout" color="error">
                <v-icon left>mdi-logout</v-icon>
                <span>Logout</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
export default {
  methods: {
    logout() {
      this.$auth.logout();
    },
  },
};
</script>
